import * as React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LogarithmicScale,
  TimeScale,
  Colors,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { logToggleState } from "@states/asset";
import { useRecoilState } from "recoil";
import { Drawer } from "@mui/material";
import Log2Axis from "./Log2Axis"
import 'chartjs-adapter-date-fns';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LogarithmicScale,
  TimeScale,
  Colors,
  Log2Axis
);
export default function PriceLogChart({ series, date }) {
  const [logToggle, setLogToggle] = useRecoilState(logToggleState);
  const options = {
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    response: false,
    animation: {
      duration: 0,
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    plugins: {
      title: {
        display: true,
        font: { size: 16 },
        text: "로그 스케일 차트" ,
      },
      tooltip: {
        enabled: true,
        titleFont: {
          size: 15,
        },
        bodyFont: {
          size: 13,
        },
        footerFont: {
          size: 13,
        },
        callbacks: {
          label: function (tooltipItem, data) {
            return (
              tooltipItem.dataset.label +
              ": " +
              Number(tooltipItem.raw)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            );
          },
        },
      },
      legend: {
        labels: {
          font: {
            weight: "bolder",
            size: 13
          }
        }
      }
    },
    scales: {
      x: {
        type: "time",
        time: {
          tooltipFormat: "yyyy-MM-dd",
          unit: "year",
          displayFormats: {
            year: "yyyy",
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 20,
        },
      },
      y: {
        display: true,
        type: "log2",
        ticks: {
          autoSkip: true,
        },
      },
    },
  };

  const palette = ["#008FFB","#00E396","#FEB019","#FF4560","#775DD0","#3F51B5","#03A9F4","#4CAF50","#F9CE1D","#FF9800","#33B2DF","#546E7A","#D4526E","#13D8AA","#A5978B","#4ECDC4","#C7F464","#81D4FA","#546E7A","#FD6A6A","#2B908F","#F9A3A4","#90EE7E","#FA4443","#69D2E7","#449DD1","#F86624","#EA3546","#662E9B","#C5D86D","#D7263D","#1B998B","#2E294E","#F46036","#E2C044","#662E9B","#F86624","#F9C80E","#EA3546","#43BCCD","#5C4742","#A5978B","#8D5B4C","#5A2A27","#C4BBAF","#A300D6","#7D02EB","#5653FE","#2983FF","#00B1F2"]
  
  const datasets = series?.map((v, idx) => {
    return {
      type: "line",
      label: v.name,
      data: v.data,
      borderWidth: 1,
      radius: 0,
      backgroundColor: palette[idx],
      borderColor: palette[idx],
      xValueType: "dateTime",
    };
  });

  return (
    <Drawer
      style={{ zIndex: 9999 }}
      PaperProps={{
        sx: {
          borderRadius: "0 0 5% 5%",
          width: "100%",
          height: "500px",
          p: 2
        },
      }}
      anchor={"top"}
      open={logToggle}
      onClose={() =>setLogToggle(false)}
    >
      <Line
        options={options}
        data={{ labels: date, datasets: datasets }}
        width={"100%"}
        height={"50%"}
      />
    </Drawer>
  );
}
